module.exports = __webpack_public_path__ + "img/promo-2-mock.14fe841c.png";